import { uniqueId } from "lodash-es";

const defaultSportsSchedule = {
    title: "",
    types: [],
    url: "",
    thumbnail: "",
    media: ["web"],
    startTime: "",
    endTime: "",
};

export const generateSportsSchedule = (props = {}) => ({
    id: uniqueId("sports-schedule"),
    ...defaultSportsSchedule,
    ...props,
});

const defaultRadioSchedule = {
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    epochStart: "",
    epochEnd: "",
    title: "",
    url: "",
    networkName: "",
};

export const generateRadioSchedule = (props = {}) => ({
    id: uniqueId("radio-schedule"),
    ...defaultRadioSchedule,
    ...props,
});
